import { useQueryClient } from 'react-query';
import { useTracking } from '@vfit/shared/data-access';
import { SoftManagerService } from '@vfit/consumer/providers';
import { getProductCategory, IProduct } from '@vfit/consumer/data-access';
import { removeCurrency } from '@vfit/consumer/hooks';

interface ITaggingHomepage {
  product: IProduct;
}

const TopNavigationLiteCardPopupTagging = ({ product }: ITaggingHomepage) => {
  const client = useQueryClient();
  useTracking({
    event: ['view'],
    event_label: 'offer requirements',
    opts: {
      event_category: 'sales',
      page_type: 'pop up',
      journey_type: 'task',
      product_target_segment: 'consumer',
      page_section: `${getProductCategory(product.offerType || '')} offers`,
      page_subsection: 'offer requirements',
    },
    pageProduct: {
      product_id: `${
        product?.isLandingClub ? product?.campaignIdLanding || product?.offerId : product?.offerId
      }`,
      product_name: product?.slug,
      product_category: getProductCategory(product?.offerType || ''),
      product_price: product?.price && removeCurrency(product.price),
      product_quantity: '1',
    },
    visitorTrackingOpts: SoftManagerService(client).getUser(),
    disableInitialTrack: false,
  });
  return null;
};

export default TopNavigationLiteCardPopupTagging;
